import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import trLocal from "./locales/tr";
import enLocal from "./locales/en";
import csLocal from "./locales/cs";

// Local kaynaklar
const localResources = {
  tr: { translation: trLocal },
  en: { translation: enLocal },
  cs: { translation: csLocal },
};

// Server'dan gelen dil bilgisini al (SSR ise)
const getInitialLanguage = () => {
  if (typeof window !== "undefined" && (window as any).__SSR_LANG__) {
    return (window as any).__SSR_LANG__;
  }
  return "tr";
};

// i18n başlat
i18n.use(initReactI18next).init({
  resources: localResources,
  lng: getInitialLanguage(),
  fallbackLng: "tr",
  interpolation: {
    escapeValue: false,
  },
  // SSR için önemli: Suspend değil, hemen yükle
  initImmediate: false,
});

export default i18n;
